export default "__VITE_ASSET__CEfid1ZT__"